<section
    id="breadcrumb"
    [class]="
        'breadcrumb__area include-bg vb-breadcrumb' +
        (full_width ? ' breadcrumb__padding' : '')
    ">
    <div class="container-fluid">
        <div>
            <div class="breadcrumb__content p-relative z-index-1">
                <vb-breadcrumb
                    class="breadcrumb__trail"
                    [trail]="crumbTrail"
                    [showBack]="true"
                    (back)="goBack()"
                    (crumbSelect)="onCrumbSelect($event)"></vb-breadcrumb>
                <div
                    class="vb-page-heading"
                    [class.vb-page-heading--hero]="heroTitle"
                    *ngIf="!disableTitle">
                    <div class="vb-page-heading__main">
                        <div class="vb-page-heading__title-row">
                            <h2
                                *ngIf="auctionId && !lotId"
                                class="vb-title-lg vb-page-title">
                                {{ auctionTitle }}
                            </h2>
                            <vb-icon-button
                                *ngIf="auctionId && !lotId && currentUserId"
                                icon="alarm"
                                [label]="showToolTipText()"
                                [active]="isWatching"
                                (clicked)="showSchedulerDialog()" />
                            <h2 *ngIf="lotId" class="vb-title-lg vb-page-title">
                                {{ lotTitle }}
                            </h2>
                            <h2
                                *ngIf="!auctionId && !lotId && !title"
                                class="vb-title-lg vb-page-title">
                                All Auctions
                            </h2>
                            <h2 *ngIf="title" class="vb-title-lg vb-page-title">
                                {{ title | titlecase }}
                            </h2>
                        </div>
                    </div>
                    <!-- Page-owned actions (e.g. the Auction summary button) -->
                    <div class="vb-page-heading__actions">
                        <ng-content select="[headingActions]"></ng-content>
                    </div>
                </div>
            </div>
            <vb-bidding-instruction-display *ngIf="instruction" class="col-xxl-3 p-0" [instruction]="instruction" />
        </div>
    </div>
</section>

<vb-dialog
    *ngIf="auction"
    [open]="showReminderDialog"
    [eyebrow]="auctionTitle"
    [title]="'AuctionsPage.auctionReminders' | translate"
    (closed)="closeReminderDialog()">
    <vb-scheduler-dialog
        *ngIf="showReminderDialog"
        [auction]="auction"
        (remindersChange)="onRemindersChange($event)"
        (closeReminders)="closeReminderDialog()" />
    <vb-button
        dialogFooter
        variant="secondary"
        [fullWidth]="true"
        (clicked)="closeReminderDialog()">
        {{ "LotDetails.close" | translate }}
    </vb-button>
</vb-dialog>
